import Routes from "./routers/routes";
import "./assets/styles/App.scss";
import "@progress/kendo-theme-default/dist/all.css";
import 'antd/dist/antd.css'
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import "./App.css";

function App(props: any) {
  const { t } = useTranslation(["consentRmf"]);
  const history = useHistory();
  const dispatch = useDispatch();
  const { loader} = useSelector((state: any) => state);

  useEffect(() => {
    let param_from: string | null | any = localStorage.getItem("param_from");
    let param_reques: string | null | any = localStorage.getItem("param_reques");

    console.log('param_from',param_from);
    console.log('param_reques',param_reques);

    if (param_from?.length > 0 && param_reques?.length > 0 && !loader.isFetchedUser) {
      setTimeout(() => {
        dispatch({
          type: "isFetchedUser",
          payload: true,
        });
      }, 1500);
    } else {
      history.push("/");
      localStorage.clear();
    }
  }, []);
  return <Routes />;
}
export default App;

